export default {
  header: 'We need to verify your phone number',
  buttons: {
    confirm: 'Confirm',
  },
  toasts: {
    invalid_code: 'Invalid code. Please try again.',
  },
};
